<template>

<div class="checklist" :class="{'is-expanded': is.expanded}">

    <div class="checklist-item-wrapper">

        <div v-for="(text, key) in options" :key="key" class="checklist-item" :class="{'is-active': isSelected(key)}" v-on:click="onItemClick(key)">

            <div class="checklist-item-text">{{ text }}</div>
            <div class="checklist-item-check"><app-icon name="check" /></div>

        </div>

    </div>

    <div class="checklist-expand" v-on:click="onExpandClick" v-if="size > 10">

        <template v-if="!is.expanded">{{ page.filter_general_expand }}</template>
        <template v-if="is.expanded">{{ page.filter_general_collapse }}</template>

    </div>

</div>

</template>

<script>

export default {

    props: ['options', 'value'],

    data: function() {

        return {
            is: {
                expanded: false
            }
        }

    },

    computed: {

        size: function() {

            return this.$_.keys(this.options).length

        }

    },

    methods: {

        onExpandClick: function() {

            this.is.expanded = !this.is.expanded

        },

        isSelected: function(value) {

            return this.$_.contains(this.value, parseInt(value))

        },

        onItemClick: function(value) {

            var values = this.$_.clone(this.value)

            if (this.$_.contains(values, parseInt(value))) {

                values.splice(values.indexOf(parseInt(value)), 1)

            } else {

                values.push(parseInt(value))

            }

            this.$emit('input', values)

        }

    }

}

</script>

<style scoped>

.checklist {
    display: flex;
    flex-direction: column;
}

.checklist-item-wrapper {
    max-height: 338px;
    overflow: hidden;
}

.checklist.is-expanded .checklist-item-wrapper {
    max-height: 100000px;
}

.checklist-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 2px;
}

.checklist-item:last-child {
    margin-bottom: 0px;
}

.checklist-item-text {
    font-size: 12px;
    line-height: 16px;
    text-transform: uppercase;
    color: var(--color-grey-dark);
    flex-grow: 1;
    padding-right: 20px;
}

.checklist-item-check {
    width: 32px;
    height: 32px;
    border: 1px solid var(--color-grey-light);
    color: var(--color-grey-light);
    text-align: center;
    cursor: pointer;
    border-radius: 4px;
    line-height: 30px;
    font-size: 16px;
    transition: all 100ms linear;
}

.checklist-item-check:hover {
    border-color: var(--color-grey-highlight);
    color: var(--color-grey-highlight);
}

.checklist-item.is-active .checklist-item-check {
    border-color: var(--color-blue-light);
    background-color: var(--color-blue-light);
    color: #fff;
}

.checklist-item.is-active .checklist-item-check:hover {
    border-color: var(--color-blue-dark);
    background-color: var(--color-blue-dark);
    color: #fff;
}

.checklist-expand {
    font-size: 12px;
    text-transform: uppercase;
    text-align: center;
    cursor: pointer;
    line-height: 12px;
    margin-top: 20px;
    color: var(--color-blue-light);
}

.is-desktop .checklist-expand:hover {
    color: var(--color-blue-dark);
}

</style>
